import { type AccountAttributes } from './generated/AccountAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { HasExtensionFields } from './concerns/HasExtensionFields';

interface Account extends AccountAttributes, HasExtensionFields {}

@model
@HasExtensionFields
class Account extends ApplicationModel {
  // Start auto-generated
  static typename: 'Account' = 'Account';
  get typename(): 'Account' {
    return 'Account';
  }

  static internalTypename: 'Account' = 'Account';
  get internalTypename(): 'Account' {
    return 'Account';
  }

  static fields = {
    createdAt: attr({ readable: true }),
    domain: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    extensionFields: attr.hasMany({
      args: { filters: 'ExtensionFieldFilters' },
      readable: true,
    }),
  };
  // End auto-generated

  static async current(query) {
    return query.first().all();
  }

  constructor(attributes = {}, options = {}) {
    super(attributes, options);
    // Account has no filters, not even an id
    this.query = this.query.rewhere({});
  }
}

export default Account;
